import { type MetaFunction } from '@remix-run/node'
import productSnowmobileInsurance from './product-snowmobile.png'
// import { Link } from '@remix-run/react'

export const meta: MetaFunction = () => [
	{ title: 'Snowmobile Insurance' },
	{
		name: 'description',
		content: 'We offer insurance for your snowmobile.',
	},
]

export default function Component() {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			<h1 className="py-3 text-4xl font-black">Snowmobile Insurance</h1>
			<img
				src={productSnowmobileInsurance}
				alt="A rider operating a snowmobile in the snow"
				className="rounded-lg object-cover object-center"
			/>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				When you ride your snowmobile off of your property, you need liability
				insurance to comply with the law as well as to protect yourself. In
				addition to liability coverage, it is very inexpensive to add physical
				damage coverage to protect the investment you have made in your sled.
				Physical damage coverage options include comprehensive (which includes
				theft) and collision (if you get into an accident). To help with the
				premium, many of our snowmobile insurance companies offer a discount for
				having prior insurance, completing a snowmobile safety course, and for
				the years of riding experience you have. We'd love to talk with you
				about your snowmobile insurance needs. Please give our friendly helpful
				staff a call - 585-657-6101.
				{/* You may also be interested in learning
				about{' '}
				<Link
					to="/snowmobile-registration-and-insurance/"
					className="text-blue-600 underline"
					prefetch="intent"
				>
					registering your snowmobile
				</Link>
				. Get a{' '}
				<Link
					to="http://steeleagency.com/get-an-insurance-quote/snowmobile-quote/"
					className="text-blue-600 underline"
					prefetch="intent"
				>
					Snowmobile Insurance Quote Here
				</Link> */}
			</p>
		</main>
	)
}
